import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Col, Row, Image } from 'react-bootstrap'
import { Breadcrumb } from 'react-breadcrumbs'
import { get } from 'lodash'
import { withRouter } from 'react-router-dom'

import { Breadcrumbs } from 'Components/Breadcrumbs'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { SectionLabel } from 'Components/Section/SectionLabel'
import { SectionTitle } from 'Components/Section/SectionTitle'
import { SectionWrapper } from 'Components/Section/SectionWrapper'
import { ButtonEditInsideSection } from 'Components/Buttons/ButtonEditInsideSection'
import { UserDetailsWrapper } from 'Components/UserManagement/UserDetailsWrapper'

import { getUserById } from 'Reducers/Users/actions'
import { isClientRole } from 'Utils/Validators/roles'

import UserManagementIcon from 'Assets/Images/icons/userManagement'
import { PATHS } from 'Config/Routing/paths'
import { CONFIG } from 'Config/config'

class UserManagementDetailsView extends PureComponent {
  componentDidMount = ({ getUserById, getCities, match } = this.props) => {
    getUserById(match.params.userId)
  }

  renderBreadcrumbs() {
    return (
      <div>
        <Breadcrumbs icon={<UserManagementIcon style={{ width: 24 }} />} />
        <Breadcrumb
          data={{
            title: 'User management',
            pathname: `${PATHS.main.dashboard}${
              PATHS.dashboard.userManagement
            }`,
          }}
        />
        <Breadcrumb
          data={{
            title: 'Details',
            pathname: `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
              PATHS.dashboard.userManagement
            }`,
          }}
        />
      </div>
    )
  }

  render({ userById } = this.props) {
    const roleLabel = {
      [CONFIG.USER_ROLE.ADMIN]: 'Administrator',
      [CONFIG.USER_ROLE.CITY_MANAGER]: 'City Manager',
      [CONFIG.USER_ROLE.CLIENT_ADMIN]: 'Client Admin',
      [CONFIG.USER_ROLE.CLIENT]: 'Client',
      [CONFIG.USER_ROLE.RECRUITER]: 'Recruiter',
      [CONFIG.USER_ROLE.SPY]: 'Spy',
    }

    return (
      <LayoutDashboard>
        {this.renderBreadcrumbs()}
        <UserDetailsWrapper>
          <SectionWrapper className="section-wrapper first">
            <SectionTitle className="section-title">User Details</SectionTitle>
            <ButtonEditInsideSection
              onClickHandler={() =>
                this.props.history.push(this.props.match.url + '/edit')
              }
            />
            <Col xs={12}>
              <Col xs={10}>
                <Row>
                  <Col xs={3}>
                    <SectionLabel className="section-label">
                      First Name
                    </SectionLabel>
                    {userById.firstName}
                  </Col>
                  <Col xs={3}>
                    <SectionLabel className="section-label">
                      Last Name
                    </SectionLabel>
                    {userById.lastName}
                  </Col>
                  <Col xs={3}>
                    <SectionLabel className="section-label">
                      Mobile Phone
                    </SectionLabel>
                    {userById.mobilePhone}
                  </Col>
                </Row>
                <Row>
                  <Col xs={3}>
                    <SectionLabel className="section-label">
                      Email Address
                    </SectionLabel>
                    {userById.email}
                  </Col>
                </Row>
                <Row>
                  <Col xs={3}>
                    <SectionLabel className="section-label">Role</SectionLabel>
                    {roleLabel[userById.role] || userById.role}
                  </Col>
                  {isClientRole(userById.role) ? (
                    <Col xs={3}>
                      <SectionLabel className="section-label">
                        Client
                      </SectionLabel>
                      {get(userById.client, 'name')}
                    </Col>
                  ) : (
                    <Col xs={3}>
                      <SectionLabel className="section-label">
                        City
                      </SectionLabel>
                      {get(userById.city, 'name')}
                    </Col>
                  )}
                  <Col xs={3}>
                    <SectionLabel className="section-label">
                      Status
                    </SectionLabel>
                    {userById.status}
                  </Col>
                </Row>
              </Col>
              <Col xs={2}>
                <Image
                  src={userById.profilePicture}
                  className="profile-picture"
                />
              </Col>
            </Col>
          </SectionWrapper>
        </UserDetailsWrapper>
      </LayoutDashboard>
    )
  }
}

UserManagementDetailsView.propTypes = {
  userById: PropTypes.object.isRequired,
  getUserById: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  userById: state.users.userById,
})

UserManagementDetailsView = connect(
  mapStateToProps,
  {
    getUserById,
  },
)(UserManagementDetailsView)

export default withRouter(UserManagementDetailsView)



// WEBPACK FOOTER //
// ./src/Containers/UserManagement/UserDetails/View/index.js